import hubAPI from "../../hubAPI";

const ROOT_PATH = "api/v1/SingleRegistry";

/**
 *
 * @param {number} companyId
 * @param {string} culture
 * @returns {Promise}
 */
export const getSolutions = async (
  companyId,
  culture = localStorage.getItem("locale") ?? "pt-BR",
) => hubAPI.get(`${ROOT_PATH}/solutions/${companyId}?culture=${culture}`);

/**
 *
 * @param {number} companyId
 * @returns {Promise}
 */
export const isSingleRegistryVehicleActive = async (companyId) =>
  hubAPI.get(`${ROOT_PATH}/feature-flag/${companyId}/vehicles`);

/**
 *
 * @param {number} companyId
 * @param {number} integratorSolutionId
 * @returns {Promise}
 */
export const getSolutionsCodes = async (companyId, integratorSolutionId) =>
  hubAPI.get(
    `${ROOT_PATH}/solutions/${companyId}/codes/${integratorSolutionId}`,
  );

/**
 * @param {Number} companyId
 * @param {string} plate
 * @param {Boolean} hideCommonFields
 * @param {Object} Data
 * @param {String} Data.solutionCode
 * @param {String} Data.integratorCode
 * @param {String} Data.catalogID
 *
 * @returns {Promise}
 */
export const getRequiredFields = async (
  companyId,
  plate,
  hideCommonFields = true,
  data,
) =>
  hubAPI.post(
    `${ROOT_PATH}/solutions/${companyId}/required-fields/${plate}?hideCommonFields=${hideCommonFields}`,
    {
      solutionCode: data?.solutionCode,
      integratorCode: data?.integratorCode,
      catalogID: data?.catalogId,
    },
  );

/**
 * @param {number} CompanyId
 * @param {Array} integratorSolutionCodes
 * @returns {Promise}
 */
export const downloadVehicleTemplateFile = async (
  companyId,
  integratorSolutionCodes,
  emptyFile,
  locale = "en-US",
) =>
  hubAPI.post(
    `${ROOT_PATH}/download/${companyId}/vehicles/file-template/${emptyFile}?culture=${locale}`,
    {
      IntegratorSolutionCodes: integratorSolutionCodes,
    },
    {
      responseType: "blob",
    },
  );

/**
 * @param {number} CompanyId
 * @param {FormData} formData
 * @returns {Promise}
 */
export const uploadFileVehicles = async (
  companyId,
  formData,
  axiosConfig = {},
  locale = "en-US",
) =>
  hubAPI.post(
    `${ROOT_PATH}/upload/${companyId}/vehicles?culture=${locale}`,
    formData,
    axiosConfig,
  );

/**
 * @param {number} companyId
 * @param {Object} data - Objeto correspondente ao ImportVehicleBatchDto
 * @param {number} data.companyUploadId
 * @returns {Promise}
 */
export const importVehicleBatch = async (companyId, data) =>
  hubAPI.post(`${ROOT_PATH}/import/${companyId}/vehicles`, data);

export const getCheckVehiclePlateExists = async (companyId, plate) =>
  hubAPI.get(`${ROOT_PATH}/${companyId}/vehicles/plate/${plate}/exists`);

export const getDrivers = async (companyId, { name, pageIndex, pageSize }) => {
  return hubAPI.get(`${ROOT_PATH}/${companyId}/drivers`, {
    params: { name, pageIndex, pageSize },
  });
};

export const createVehicle = async (
  companyId,
  { companyID, ownershipStatusID, plate, vehicleName, driverID },
) => {
  return hubAPI.post(`${ROOT_PATH}/${companyId}/vehicles`, {
    companyID,
    ownershipStatusID,
    plate,
    vehicleName,
    driverID,
  });
};

/**
 * @param {number} companyId
 * @param {Object} filters
 * @param {string} [filters.search]
 * @param {string} [filters.status]
 * @param {string} [filters.platform]
 * @param {string} [filters.operation]
 * @param {number} [filters.pageIndex]
 * @param {number} [filters.pageSize]
 * @param {string} [filters.sortProperty]
 * @param {string} [filters.sortDirection]
 * @returns {Promise}
 */
export const getSynchronizedHistoricList = async (companyId, filters) => {
  return hubAPI.get(`${ROOT_PATH}/${companyId}/synchronization-history`, {
    params: filters,
  });
};

/**
 * @param {number} companyId
 * @param {number} vehicleId
 * @param {Object} data - Objeto correspondente ao SaveSharedCharacteristicsRequestDTO
 * @returns {Promise}
 */
export const checkSharedCharacteristicsImpact = async (
  companyId,
  vehicleId,
  data,
) =>
  hubAPI.post(
    `${ROOT_PATH}/${companyId}/vehicles/${vehicleId}/shared-characteristics/check-impact`,
    data,
  );

/**
 * Updates the shared characteristics of a vehicle in the GoHub core system.
 *
 * @param {number} companyId
 * @param {number} vehicleId
 * @param {Object} data - Objeto correspondente ao SaveSharedCharacteristicsRequestDTO
 * @param {number} [data.VehicleBrandId]
 * @param {number} [data.VehicleModelId]
 * @param {number} [data.VehicleVersionId]
 * @param {string} [data.Motorization]
 * @param {number} [data.Year]
 * @param {number} [data.YearFabrication]
 * @param {string} [data.ChassisNumber]
 * @param {string} [data.Color]
 * @param {string} [data.LicenceNumber]
 * @param {number} [data.OdometerInitial]
 * @param {number} [data.TankCapacity]
 * @returns {Promise}
 */
export const updateSharedCharacteristics = async (companyId, vehicleId, data) =>
  hubAPI.post(
    `${ROOT_PATH}/${companyId}/vehicles/${vehicleId}/shared-characteristics`,
    data,
  );

/**
 *
 * @param {Number} companyId
 * @param {Number} vehicleId
 * @param {String} integratorCode
 * @param {String} locale
 * @returns {Promise}
 */
export const getVehicleStatusInSolutions = async (
  companyId,
  vehicleId,
  integratorCode,
  locale = localStorage.getItem("locale") ?? "pt-BR"
) =>
  hubAPI.get(
    `${ROOT_PATH}/${companyId}/vehicles/${vehicleId}/solutions/${integratorCode}?culture=${locale}`,
  );

/**
 *
 * @param {Number} id
 * @param {Number} companyID
 * @returns {Promise}
 */
export const checkVehicleExistsInSolutions = async (id, companyID) =>
  hubAPI.get(
    `${ROOT_PATH}/solutions/${companyID}/exists-in-solutions/vehicle/${id}`,
  );

/**
 * Updates vehicle data specifically for the GoHub tab.
 * Temporarily uses the legacy putvehiclesfrontend endpoint.
 *
 * @param {number} companyId
 * @param {number} vehicleId
 * @param {string} culture
 * @param {Object} payload - Vehicle data payload
 * @returns {Promise}
 */
export const updateVehicleGoHubData = async (
  companyId,
  vehicleId,
  culture,
  payload,
) =>
  hubAPI.put(
    `api/v1/Company/${companyId || 0}/putvehiclesfrontend/${vehicleId || 0}?culture=${culture}`,
    payload,
  );

/**
 * Updates vehicle tanks specifically for the GoHub tab.
 * Temporarily uses the legacy putvehicletankfrontend endpoint.
 *
 * @param {number} companyId
 * @param {number} vehicleId
 * @param {string} culture
 * @param {Array} payload - Vehicle tanks payload
 * @returns {Promise}
 */
export const updateVehicleGoHubTanks = async (
  companyId,
  vehicleId,
  culture,
  payload,
) =>
  hubAPI.put(
    `api/v1/Company/${companyId || 0}/putvehicletankfrontend/${vehicleId || 0}?culture=${culture}`,
    payload,
  );

/**
 * Saves a vehicle card.
 *
 * @param {number} companyId
 * @param {Object} payload - Card data
 * @returns {Promise}
 */
export const saveVehicleCard = async (companyId, payload) =>
  hubAPI.post(`api/v1/Company/${companyId}/saveVehicleCard`, payload);

/**
 * Verifica se o novo tankCapacity do veículo conflita com os limites
 * de combustível configurados nas soluções.
 *
 * @param {number} companyId
 * @param {number} vehicleId
 * @param {number} tankCapacity - Novo valor a ser validado
 * @returns {Promise<{ data: { hasConflict: boolean } }>}
 */
export const checkTankCapacityInSolutions = async (
  companyId,
  vehicleId,
  tankCapacity,
) =>
  hubAPI.get(
    `${ROOT_PATH}/${companyId}/vehicles/${vehicleId}/shared-characteristics/check-tank-capacity/${tankCapacity}`,
  );

  /**
 * Descarta um upload ainda não processado.
 *
 * @param {number|string} companyId - Identificador da empresa.
 * @param {number|string} companyUploadId - Identificador do upload.
 * @returns {Promise}
 */
export const discardUpload = async (companyId, companyUploadId) =>
  hubAPI.delete(`${ROOT_PATH}/${companyId}/uploads/${companyUploadId}`);
